import React from 'react';
import { useTranslation } from 'react-i18next';

const FieldFeedback = ({ field, errors, counters, config }) => {
  const { t } = useTranslation();

  // 1. Safety check: if field is not in config, show nothing
  if (!config || !config[field]) return null;

  const fieldConfig = config[field];
  const errorMessage = errors[field];
  const isSelectField = fieldConfig.isSelect; // Check for combo/select type

  return (
    <div className="d-flex justify-content-between mt-1" style={{ minHeight: '1.2rem' }}>
      {/* ERROR MESSAGE (Left side) */}
      <div className="flex-grow-1">
        {errorMessage && (
          <small className="text-danger animate__animated animate__fadeIn">
            {errorMessage}
          </small>
        )}
      </div>

      {/* CHARACTER COUNTER (Right side) - Only if NOT a Select */}
      {!isSelectField && (
        <div className="text-end" style={{ minWidth: '100px' }}>
          <span className={`small ${(counters[field] || 0) > fieldConfig.max ? 'text-danger fw-bold' : 'text-muted'}`}>
            {counters[field] || 0}/{fieldConfig.max} {t("label.characters")}
          </span>
        </div>
      )}
    </div>
  );
};

export default FieldFeedback;
